<script>
    export let field
    export let detailed

    const AllScopes = ['SAR', 'DDR', 'RET']

    function hasScope(field, scope) {
        return field.scopes.find(s => s === scope)
    }

    function scopeGiven(detailed, it) {
        switch(it) {
            case 'SAR'   : return detailed ? 'Acesso'      : 'SAR'
            case 'DDR'   : return detailed ? 'Deleção'     : 'DDR'
            case 'RET'   : return detailed ? 'Retificação' : 'RET'
            case 'FIXED' : return detailed ? 'Fixo'        : 'FIX'
            case 'KEEP'  : return detailed ? 'Fixo'        : 'FIX'
            default      : return it 
        }
    }    

</script>

<!-- {JSON.stringify(field)} -->
{#each AllScopes as scope}
    <span   class="ui label"
            class:detailed
            class:tiny={!detailed}
            class:circular={!detailed}
            class:disabled={!hasScope(field, scope)}
            class:basic={!hasScope(field, scope)}>{scopeGiven(detailed, scope)}</span>
{/each}

<style>
    .ui.label.detailed {
        display: block;
        margin: .5em 0;
        float: left;
        clear: left;
    }
</style>
